// Tracks which navbar popover (friends, notifications, user-menu) is
// currently open so they can be mutually exclusive. Opening one closes
// the others; clicking outside closes whatever is open.

class PopoverStateManager {
  constructor() {
    /** @type {Set<(openId: string|null) => void>} */
    this._listeners = new Set();
    /** @type {string|null} */
    this.openId = null;
  }

  /** @param {(openId: string|null) => void} listener */
  subscribe(listener) {
    this._listeners.add(listener);
    return () => this._listeners.delete(listener);
  }

  /** @param {string} id */
  open(id) {
    if (this.openId === id) return;
    this.openId = id;
    this._notify();
  }

  /** @param {string} id */
  close(id) {
    if (this.openId !== id) return;
    this.openId = null;
    this._notify();
  }

  /** @param {string} id */
  toggle(id) {
    if (this.openId === id) {
      this.openId = null;
    } else {
      this.openId = id;
    }
    this._notify();
  }

  closeAll() {
    if (this.openId === null) return;
    this.openId = null;
    this._notify();
  }

  _notify() {
    for (const l of this._listeners) {
      try {
        l(this.openId);
      } catch (err) {
        console.error('[popover-state] listener threw', err);
      }
    }
  }
}

export const popoverState = new PopoverStateManager();
